<template>
  <v-dialog
    :value="dialog"
    :width="1000"
    persistent
    :retain-focus="false"
    scrollable
    @keydown.esc="escape(closeDialog)"
    @click:outside="escape(closeDialog)"
  >
    <v-card outlined>
      <v-card-title>
        {{ $t('note.createNote') }}
        <p-btn-icon
          type="close"
          btn-class="mr-n3 ml-auto"
          @click="escape(closeDialog)"
        ></p-btn-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="form" @submit.stop.prevent>
          <v-container>
            <v-row class="pt-5">
              <v-col>
                <v-text-field
                  v-model.trim="newNote.title"
                  :label="$t('note.edit.title')"
                  :rules="rules.title"
                  type="text"
                  prepend-icon="mdi-text-short"
                  tabindex="1"
                  clearable
                  validate-on-blur
                  autofocus
                >
                </v-text-field>

                <div class="mt-4 ml-9">
                  <PSyncfusionRichTextEditor
                    v-model="newNote.text"
                    :label="$t('note.edit.text')"
                    :height="500"
                    tabindex="1"
                    />
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center">
        <v-btn
          text
          @click="closeDialog"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          :disabled="!isModelChanged()"
          color="primary"
          text
          @click.prevent="submit">{{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapActions } from 'vuex'

import PBtnIcon from '@/components/PBtnIcon'
import PSyncfusionRichTextEditor from '@/components/PSyncfusionRichTextEditor'

import dialogMixin from '@/mixins/dialog.mixin'
import unsavedChangesMixin from '@/mixins/unsavedChanges.mixin'
import snackbarMixin from '@/mixins/snackbar.mixin'
import validationMixin from '@/mixins/validation.mixin'


export default {
  components: {
    PBtnIcon,
    PSyncfusionRichTextEditor
  },


  mixins: [
    dialogMixin,
    unsavedChangesMixin,
    snackbarMixin,
    validationMixin
  ],


  data () {
    return {
      newNote: {}
    }
  },


  computed: {
    rulesToApply () {
      const rule = this.rule

      return {
        title: [rule.required()]
      }
    }
  },


  methods: {
    ...mapActions('note', ['createNote']),

    onDialogOpen () {
      this.newNote = {
        title: '',
        text: ''
      }
      this.initWatchedModel('newNote')
    },

    async submit () {
      const valid = await this.validate(this.rulesToApply)
      if (!valid || !this.isModelChanged()) return
      try {
        this.showSnackbarProcessing()
        await this.createNote(this.newNote)
        this.showSnackbarSuccess(this.$t('note.noteCreated'))
        this.closeDialog()
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    }
  }
}
</script>
